<template>
  <div class="contact">
    <div class="banner-back">
      <div style="height: 140px;"></div>
      <div class="titles content-center">立即开启您的数智化国际物流之旅</div>
      <div class="title-desc content-center">请填写表单信息，e航无忧团队将尽快与您联系！</div>
      <div class="content-center">
        <div class="content-box">
          <div style="margin: 0 81px;" v-if="!isSuccess">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item label="姓名" prop="name" style="margin-top: 10px;">
                <el-input v-model="ruleForm.name" placeholder="请输入姓名" maxlength="10" style="width: 560px;" />
              </el-form-item>
              <el-form-item label="电子邮箱" prop="email">
                <el-input v-model="ruleForm.email" placeholder="请输入电子邮箱" style="width: 560px;" />
              </el-form-item>
              <el-form-item label="手机" prop="phone">
                <el-input v-model="ruleForm.phone" maxlength="11" placeholder="请输入手机号码" style="width: 560px;" />
              </el-form-item>
              <el-form-item label="公司名称" prop="">
                <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称" style="width: 560px;" />
              </el-form-item>
              <el-form-item label="公司所在地区（省市）" prop="">
                <div class="region-box">
                  <regionSelect @getRegionData="getRegionData" ref="child" :regionArr='regionArr' :type="2"></regionSelect>
                </div>
              </el-form-item>
              <el-form-item label="公司详细地址" prop="">
                <el-input v-model="ruleForm.address" maxlength="11" placeholder="请输入公司详细地址" style="width: 560px;" />
              </el-form-item>
              <el-form-item label="职位" prop="">
                <el-select v-model="ruleForm.position" placeholder="请选择职位" style="width: 560px;">
                  <el-option v-for="item in positionList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="部门" prop="">
                <el-select v-model="ruleForm.department" placeholder="请选择部门" style="width: 560px;">
                  <el-option v-for="item in departmentList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="港口" prop="">
                <el-select v-model="ruleForm.port" placeholder="请选择港口" style="width: 560px;">
                  <el-option v-for="item in portList" :key="item.code" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 481px;">
                <el-checkbox v-model="checked" style="float:left"></el-checkbox>
                <div class="checkbox-div">我已阅读并接受<span @click.stop="privacyDialogVisible = true">《产品隐私声明》</span>，并同意通过电话、短信、电子邮件或其他电子方式接收e航无忧产品和服务信息。</div>
                <div class="btn content-center" @click="submitForm('ruleForm')">提交</div>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="isSuccess">
            <el-result icon="success" title="信息保存成功" subTitle="请根据提示进行操作">
              <template slot="extra">
                <el-button type="primary" size="medium" @click="isSuccess = false">返回</el-button>
              </template>
            </el-result>
          </div>


        </div>
      </div>
    </div>
    <privacy :visible.sync="privacyDialogVisible"></privacy>
  </div>
</template>

<script>
import regionSelect from "../../components/select/RegionSelect"
import privacy from "../../components/Privacy"
import { httpAjax } from "@/api/ajax"

export default {
  components:{
    regionSelect,
    privacy
  },
  name: "contact",
  data() {

    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }

    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        // Number.isInteger是es6验证数字是否为整数的方法,但是我实际用的时候输入的数字总是识别成字符串
        // 所以我就在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }

    return {
      checked: false,
      isSuccess:false,
      ruleForm: {
        name: '',
        email: '',
        phone: '',
        companyName: '',
        position: '',
        department: '',
        port: '',
        province: '',
        city: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        email: [
          {required: true, message: '请输入电子邮箱', trigger: 'blur'},
          { validator: checkEmail, trigger: 'blur' }
        ],
        phone: [
          {required: true, message: '请输入电话', trigger: 'blur'},
          { validator: checkPhone, trigger: 'blur' }
        ]
      },
      departmentList: [],
      positionList: [],
      regionArr: [],  //地区数据
      privacyDialogVisible:false, //隐私政策
      portList:[
        {code:'shanghai',name:'上海'},
        {code:'qingdao',name:'青岛'},
        {code:'ningbo',name:'宁波'}
      ]
    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      httpAjax({
        url:'/services/crm/enums',
        method:'get'
      }).then((res) => {
        if(res && res.success){
          this.departmentList = res.data.department
          this.positionList = res.data.position
        }
      });
    },
    submitForm(form){
      this.$refs[form].validate((valid) => {
        if(valid){
          if(!this.checked){
            this.$message({
              message: '请勾选产品隐私声明',
              type: 'error'
            })
            return
          }else{
            httpAjax({
              url:'/services/crm/add',
              method:'post',
              data: this.ruleForm
            }).then((response) => {
              if(response.success) {
                this.$message({
                  message: '信息保存成功！',
                  type: 'success'
                })
                this.ruleForm={
                  name: '',
                  email: '',
                  phone: '',
                  companyName: '',
                  position: '',
                  department: '',
                  port: '',
                  province: '',
                  city: ''
                }
                this.$refs.child.resetData();
                this.checked  = false;
                this.isSuccess = true
                this.regionArr = []
                // this.$router.push({path:'/aboutUs'});
              } else {
                this.$message({
                  message: response.msg,
                  type: 'error'
                })
              }
            });
          }
        }
      })
    },
    //获取地区选择组件的数据
    getRegionData(...data){
      this.regionArr = data;
      console.log(data);
      this.ruleForm.province = data[4][1];
      this.ruleForm.city = data[4][2];
      //this.$refs['form'].clearValidate('companyAddress');
    }
  },
};
</script>

<style scoped lang="less">
/deep/ .el-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkbox-div {
  width: 545px;
  word-wrap: break-word;
  word-break: break-all;
  white-space: pre-line;
  margin-left: 21px;
  margin-top: -5px;
  line-height: 22px;
  span {
    display: inline-block;
    color: #00a0e9;
    cursor: pointer;
  }
}
.contact {
  overflow: auto;
  height: 100vh;
  background-color: #ffffff;

  /deep/ .el-form-item__label {
    display: block !important;
    width: 500px;
    text-align: left;
  }
  .content-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .banner-back {
    height: 306px !important;
    background-image: url("https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/official/contactUs-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top center;
    box-shadow: 0px 20px 20px rgba(137, 137, 137, 0.13);

    .titles {
      font-size: 36px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #f2f5fa;
      line-height: 63px;
      margin-bottom: 120px;
    }
    .title-desc {
      margin: 16px 0;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #222222;
      line-height: 30px;
    }

    .content-box {
      display: flex;
      justify-content: center;
      // align-items: center;
      width: 582px;
      // height: 900px;
      background: #fff;
      // box-shadow: 0 2px 18px #595b5e;
      border-radius: 8px;
    }

    .btn {
      width: 560px;
      height: 64px;
      background: linear-gradient(90deg, #00a0e9 0%, #44caff 100%);
      box-shadow: 0px 4px 16px 0px #10a9ee;
      border-radius: 5px;
      font-size: 24px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;
      margin-top: 40px;
      margin-bottom: 60px;
    }
  }

  .div-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    flex-direction: column;
  }

  .content {
    color: #707070;
    width: 1000px;
    line-height: 26px;
    font-size: 14px;
    margin-bottom: 30px;
  }
}
</style>